import dayjs from 'dayjs';

// Placeholder until the real blank agreement file link is provided.
export const AGRONOMY_AGREEMENT_BLANK_AGREEMENT_URL = '#';

export const AGRONOMY_AGREEMENT_MIN_START_DATE = dayjs().subtract(30, 'day');
export const AGRONOMY_AGREEMENT_MAX_START_DATE = dayjs().add(12, 'months');

export const AGRONOMY_MAX_DURATION_YEARS = 2;
